import { render, staticRenderFns } from "./StatsRemote.vue?vue&type=template&id=1a763953"
import script from "./StatsRemote.vue?vue&type=script&lang=js"
export * from "./StatsRemote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports